import { createElement } from "react";
import React from "react";
import { useEffectWithDeps } from "../fable_modules/Feliz.2.9.0/ReactInterop.js";
import { Msg } from "../App/Messages.js";
import { createObj } from "../fable_modules/fable-library-js.4.28.0/Util.js";
import { singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.28.0/Seq.js";
import { t } from "../Lang.js";
import { App_goToDashboard, Contact_sending, Contact_attachmentsHint, Contact_attachments, Contact_descriptionPlaceholder, Contact_description, Contact_subjectPlaceholder, Contact_subject, Contact_emailPlaceholder, Contact_email, Contact_submit, Contact_success, Contact_intro, Contact_title } from "../Shared/Tr.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { ofArray } from "../fable_modules/fable-library-js.4.28.0/List.js";
import { defaultOf } from "../fable_modules/fable-library-js.4.28.0/Util.js";

function TurnstileContactWidget(turnstileContactWidgetInputProps) {
    const dispatch = turnstileContactWidgetInputProps.dispatch;
    useEffectWithDeps(() => {
        const widgetId = (function(id, key, cb) {
                    if (typeof turnstile !== 'undefined') {
                        return turnstile.render('#' + id, { sitekey: key, callback: cb });
                    }
                    return '';
                })("turnstile-contact-container", "0x4AAAAAACx_qjUV1_JTYdTD", ((token) => {
            dispatch(new Msg(290, [token]));
        }));
        return {
            Dispose() {
                (function(wid) {
                        if (typeof turnstile !== 'undefined' && wid) {
                            try { turnstile.remove(wid); } catch(_) {}
                        }
                    })(widgetId);
            },
        };
    }, []);
    return createElement("div", {
        id: "turnstile-contact-container",
        className: "turnstile-widget",
    });
}

export function view(model, dispatch) {
    let elems_8, elems_7;
    const form = model.ContactForm;
    return createElement("div", createObj(ofArray([["className", "auth-container"], (elems_8 = [createElement("div", createObj(ofArray([["className", "card"], ["style", {
        maxWidth: 600 + "px",
    }], (elems_7 = toList(delay(() => append(singleton(createElement("h2", {
        children: t(Contact_title),
    })), delay(() => append(singleton(createElement("p", {
        className: "contact-intro",
        children: t(Contact_intro),
    })), delay(() => {
        let matchValue;
        return form.IsSubmitted ? append(singleton(createElement("div", {
            className: "success-message",
            children: t(Contact_success),
        })), delay(() => {
            let elems;
            return singleton(createElement("div", createObj(ofArray([["className", "auth-toggle"], (elems = [createElement("button", {
                className: "btn-link",
                children: t(Contact_submit),
                onClick: (_arg) => {
                    dispatch(new Msg(291, []));
                },
            })], ["children", reactApi.Children.toArray(Array.from(elems))])]))));
        })) : append((matchValue = form.Error, (matchValue == null) ? singleton(defaultOf()) : singleton(createElement("div", {
            className: "error-message",
            children: matchValue,
        }))), delay(() => {
            let elems_1;
            return append(singleton(createElement("div", createObj(ofArray([["className", "form-group"], (elems_1 = [createElement("label", {
                children: t(Contact_email),
            }), createElement("input", {
                className: "form-input",
                type: "email",
                placeholder: t(Contact_emailPlaceholder),
                value: form.Email,
                onChange: (ev) => {
                    dispatch(new Msg(285, [ev.target.value]));
                },
                disabled: form.IsSubmitting,
            })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
                let elems_2;
                return append(singleton(createElement("div", createObj(ofArray([["className", "form-group"], (elems_2 = [createElement("label", {
                    children: t(Contact_subject),
                }), createElement("input", {
                    className: "form-input",
                    type: "text",
                    placeholder: t(Contact_subjectPlaceholder),
                    value: form.Subject,
                    onChange: (ev_1) => {
                        dispatch(new Msg(286, [ev_1.target.value]));
                    },
                    disabled: form.IsSubmitting,
                })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => {
                    let elems_3;
                    return append(singleton(createElement("div", createObj(ofArray([["className", "form-group"], (elems_3 = [createElement("label", {
                        children: t(Contact_description),
                    }), createElement("textarea", {
                        className: "form-input",
                        placeholder: t(Contact_descriptionPlaceholder),
                        value: form.Description,
                        rows: 6,
                        onChange: (ev_2) => {
                            dispatch(new Msg(287, [ev_2.target.value]));
                        },
                        disabled: form.IsSubmitting,
                    })], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))), delay(() => {
                        let elems_4;
                        return append(singleton(createElement("div", createObj(ofArray([["className", "form-group"], (elems_4 = [createElement("label", {
                            children: t(Contact_attachments),
                        }), createElement("input", {
                            id: "contact-files",
                            className: "form-input",
                            type: "file",
                            multiple: true,
                            accept: "image/*,.pdf,.txt,.log",
                            disabled: form.IsSubmitting,
                        }), createElement("small", {
                            className: "form-hint",
                            children: t(Contact_attachmentsHint),
                        })], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))), delay(() => append(singleton(createElement(TurnstileContactWidget, {
                            dispatch: dispatch,
                        })), delay(() => {
                            let elems_5;
                            return append(singleton(createElement("div", createObj(ofArray([["className", "form-group"], (elems_5 = [createElement("button", {
                                className: "btn btn-primary",
                                style: {
                                    width: 100 + "%",
                                },
                                disabled: form.IsSubmitting ? true : (form.TurnstileToken == null),
                                children: form.IsSubmitting ? t(Contact_sending) : t(Contact_submit),
                                onClick: (_arg_1) => {
                                    if (!form.IsSubmitting) {
                                        dispatch(new Msg(288, []));
                                    }
                                },
                            })], ["children", reactApi.Children.toArray(Array.from(elems_5))])])))), delay(() => {
                                let elems_6;
                                return singleton(createElement("div", createObj(ofArray([["className", "auth-toggle"], (elems_6 = [createElement("a", {
                                    href: "#/",
                                    className: "btn-link",
                                    children: t(App_goToDashboard),
                                })], ["children", reactApi.Children.toArray(Array.from(elems_6))])]))));
                            }));
                        }))));
                    }));
                }));
            }));
        }));
    })))))), ["children", reactApi.Children.toArray(Array.from(elems_7))])])))], ["children", reactApi.Children.toArray(Array.from(elems_8))])])));
}

